<template>
  <button
    class="base-button btn"
    :class="[
      btnSize,
      btnColor,
      (loading || disabled) && '--disabled',
      loading && '--loading',
      icon && !loading && '--has-icon',
    ]"
    :type="type"
    :disabled="loading || disabled"
    @click="handleButtonClick"
  >
    <template v-if="loading">
      <span class="spinner"></span>
    </template>
    <template v-else-if="icon">
      <slot />
      <svg v-if="icon" class="icon">
        <use :xlink:href="`/img/sprites.svg#icon-${icon}`"></use>
      </svg>
    </template>
    <template v-else>
      <slot />
    </template>
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    type: {
      type: String,
      required: false,
      default: () => 'button',
    },
    size: {
      type: String,
      required: false,
      default: () => 'md',
    },
    icon: {
      type: String,
      required: false,
      default: () => '',
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  computed: {
    btnSize() {
      return `--${this.size}`;
    },
    btnColor() {
      return `--${this.color}`;
    },
  },
  methods: {
    handleButtonClick(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style scoped>
.base-button {
  position: relative;
  display: inline-flex;
  -webkit-box-pack: justify;
  -webkit-box-align: center;
  align-items: center;
  justify-content: center;
}

.base-button.--has-icon {
  justify-content: space-between;
}

.base-button > .icon {
  width: 2rem;
  height: 2rem;
  fill: #fff;
  margin-left: 1em;
}
.spin {
  animation: spin 1.2s infinite linear reverse;
}
@keyframes spin {
  to: {
    transform: rotate(0deg);
  }
  from {
    transform: rotate(360deg);
  }
}
</style>
